export default "__VITE_ASSET__8qZGxhlt__"